<template>
    <div v-if="visible">
        <el-dialog :title="teacherTitle" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="950px">    
            
            <!-- <div v-if="form.sign == 1" style="font:12px;color:red;">
                说明：<br>
                1、每个界面填写数据需先点击“保护”按钮进行数据保存，然后再切换下一个界面填写，否则已填写数据会丢失。
            </div>
            <div v-if="form.sign == 2 || form.sign == 3" style="font:12px;color:red;">
                说明：<br>
                1、每个界面填写数据需先点击“提交”按钮进行数据保存，然后再切换下一个界面填写，否则已填写数据会丢失。
            </div> -->
            <div style="z-index: 9999;position:fixed;margin-left:795px;margin-top:330px;">
                <div><el-button type="danger" round  @click="close();" style="width:120px;">关闭</el-button></div>
            </div>
            <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="课程表" name="first">
                    <child1></child1>
                </el-tab-pane>

                <el-tab-pane v-for="(item, index) in data" :key="index" :label="item.tabTitle"  :name="item.tabTitle">
                    <child2 v-if="activeName == item.tabTitle" ></child2>    
                </el-tab-pane>

            </el-tabs>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关 闭</el-button>
                <el-button type="primary" @click="visible=false">提 交</el-button>
            </span>     -->
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import course from './gkxq/Course.vue'; // 课程表
    import occupation from './gkxq/Occupation.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        components:{
            child1:course,
            child2:occupation,
        },
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    id:"",
                    sign:""
                },
                teacherTitle:"",
                //默认第一个选项卡
                activeName: "first",
                data:[]
            }
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data,sign){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId;
                sessionStorage.setItem("selectDeptId",this.form.deptId);
                sessionStorage.setItem("selectId",data.id);
                sessionStorage.setItem("selectSign",sign);
                sessionStorage.setItem("selectName",data.assessUser);

                // sign:1-填写，2-学校审批，3-学区审批，4-查看
                this.form.sign=sign;
                if(sign == 1){
                    this.teacherTitle=data.assessUser+'的绩效申报';
                }else if(sign == 2){
                    this.teacherTitle=data.assessUser+'的学校审批';
                }else if(sign == 3){
                    this.teacherTitle=data.assessUser+'的学区审批';
                }else if(sign == 4){
                    this.teacherTitle=data.assessUser+'的绩效查看';
                }
                // 初始tabl
                this.getTabName();
                // 初始位置
                this.activeName="first";
            },
            dialogClose(done){
                done();
                // this.$reload;
                this.$parent.getData();
            },
            close(){
                this.$parent.getData();
                this.visible=false
            },
            handleClick(tab) {
                this.activeName=tab.name;
                sessionStorage.setItem("selectTabTitle",this.activeName);
            },
            // 获取tab名称
            getTabName(){
                //部门管理
                let url  = this.teacherAssessIndexTabNameListUrl;
                let data = {
                    teacherAssessId:this.form.id,
                    selectSign:this.form.sign
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/teacherAssess/AssessMain.vue